import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  planChanged({ detail: { success } }) {
    if (success && Memberful.inIframe()) {
      Memberful.RpcClient.call("reloadOnCloseWith", [this.urlValue])
    }
  }
}
